import { ConsignmentSpecies, DeviceResponseStatus } from './enums';

export function speciesEnumToName(speciesEnum: ConsignmentSpecies | string | null) {
    switch (speciesEnum) {
        case ConsignmentSpecies.GOAT:
            return 'Goat';
        case ConsignmentSpecies.BOBBY_CALVES:
            return 'Bobby Calves';
        case ConsignmentSpecies.CATTLE:
            return 'Cattle';
        case ConsignmentSpecies.SHEEP_LAMB:
            return 'Sheep/Lamb';
        default:
            return;
    }
}

export function speciesEnumToPluralName(speciesEnum: ConsignmentSpecies | string | null) {
    switch (speciesEnum) {
        case ConsignmentSpecies.GOAT:
            return 'Goats';
        case ConsignmentSpecies.BOBBY_CALVES:
            return 'Bobby Calves';
        case ConsignmentSpecies.CATTLE:
            return 'Cattle';
        case ConsignmentSpecies.SHEEP_LAMB:
            return 'Sheep/Lambs';
        default:
            return;
    }
}

export const ALL_SPECIES = [
    ConsignmentSpecies.BOBBY_CALVES,
    ConsignmentSpecies.CATTLE,
    ConsignmentSpecies.GOAT,
    ConsignmentSpecies.SHEEP_LAMB,
];

export enum ConsignmentStatus {
    DRAFT = 'DRAFT',
    SUBMITTED = 'SUBMITTED',
    LOCKED = 'LOCKED',
    DELETED = 'DELETED',
    // ENVDB-7836: the API and the gateway (GraphQLGateway/DTO/Consignment.cs) have always had this;
    // the display mappings below deliberately do not cover it — that is ENVDB-6805's scope.
    UNLOCKED = 'UNLOCKED',
}

export enum GraphqlErrorType {
    Error = 'Error',
    Warning = 'Warning',
    Success = 'Success',
}

export enum UserRole {
    AUTHVIEWER = 'AUTHVIEWER',
}

export function consignmentEnumToName(statusEnum: ConsignmentStatus | string | null) {
    switch (statusEnum) {
        case ConsignmentStatus.DRAFT:
            return 'Draft';
        case ConsignmentStatus.SUBMITTED:
            return 'Submitted';
        case ConsignmentStatus.LOCKED:
            return 'Completed';
        case ConsignmentStatus.UNLOCKED:
            return 'Unlocked';
        case ConsignmentStatus.DELETED:
            return 'Deleted';
        default:
            return;
    }
}

interface ChipColorStyle {
    '--chip-bg': string;
    '--chip-border-color': string;
    '--chip-text-color'?: string;
}


export function deviceStatusEnumToColor(statusEnum: DeviceResponseStatus): ChipColorStyle {
    switch (statusEnum) {
        case DeviceResponseStatus.INACTIVE:
            return {
                '--chip-bg': 'var(--action-subtle)',
                '--chip-border-color': 'var(--border-control)',
                '--chip-text-color': 'var(--text-secondary-1)',
            };
        case DeviceResponseStatus.ACTIVE:
            return {
                '--chip-bg': 'var(--bg-success)',
                '--chip-border-color': 'var(--status-success)',
                '--chip-text-color': 'var(--text-success)',
            };
        case DeviceResponseStatus.NOT_FOUND:
            return {
                '--chip-bg': 'var(--bg-error)',
                '--chip-border-color': 'var(--status-error)',
                '--chip-text-color': 'var(--text-secondary-1)',
            };
        case DeviceResponseStatus.UNAUTHORIZED:
            return {
                '--chip-bg': 'var(--bg-warning)',
                '--chip-border-color': 'var(--status-warning)',
                '--chip-text-color': 'var(--text-secondary-1)',
            };
        default:
            return {
                '--chip-bg': 'var(--action-subtle)',
                '--chip-border-color': 'var(--border-control)',
                '--chip-text-color': 'var(--text-secondary-1)',
            };
    }
}

export function deviceStatusEnumToName(statusEnum: DeviceResponseStatus) {
    switch (statusEnum) {
        case DeviceResponseStatus.INACTIVE:
            return 'Inactive';
        case DeviceResponseStatus.ACTIVE:
            return 'Active';
        case DeviceResponseStatus.NOT_FOUND:
            return 'Not found';
        case DeviceResponseStatus.UNAUTHORIZED:
            return 'Unauthorised';
        default:
            return;
    }
}

export function mapConsignmentToDeviceSpecies(consignmentSpecies: ConsignmentSpecies): string {
    switch (consignmentSpecies) {
        case ConsignmentSpecies.SHEEP_LAMB:
            return 'Sheep';
        case ConsignmentSpecies.GOAT:
            return 'Goats';
        case ConsignmentSpecies.CATTLE:
            return 'Cattle';
        case ConsignmentSpecies.BOBBY_CALVES:
            // ENVDB-8077: NLIS has no bobby-calf species; bobby calves wear cattle devices,
            // so a Bobby Calves consignment must accept devices whose NLIS species is "Cattle".
            return 'Cattle';
    }
}
